import { Box } from "@mui/material";

interface NavigationMenuItemsWrapperDesktopProps {
  children: React.ReactNode;
}

export function NavigationMenuItemsWrapperDesktop(props: NavigationMenuItemsWrapperDesktopProps) {
  const { children } = props;

  return (
    <Box
      aria-label="Navigation menu"
      sx={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "300px",
        gap: 1,
        paddingY: 2,
        paddingX: 4,
        overflowY: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        maskImage:
          "linear-gradient(to bottom, transparent, black 16px, black calc(100% - 16px), transparent)",
      }}
    >
      {children}
    </Box>
  );
}
